Vue.asyncComponent('ak-locale-toggle', {
    computed: {
        activeLocale() {
            return this.$localeHandler.getActiveLocale();
        },
        currentLocales() {
            return this.$localeHandler.getLocales();
        }
    },
}, 'locale/ak-locale-toggle.html');